import React from 'react';
import Navbar from './Navbar'; 
import './App.css'; 
import ImageGallery from './ImageGallery';
import logo from './img/logo8.png';
import Accesso from './img/Design/acceso.jpg';
import Box from './img/Design/box.jpg';
import Campus from './img/Design/campus.jpg';
import Samsung from './img/Design/samsung.jpg';
import Card from './img/Design/card.jpg';
import Coffee from './img/Design/coffee.jpg';
import Program from './img/Design/bova.jpg'
import Lon from './img/Design/lon_d.jpg'
import Car from './img/Design/car.jpg'
import Cleaner from './img/Design/cleanercover.jpg'
import Sora from './img/Design/soracover.jpg'
import NewYear from './img/Design/newyearcover.jpg'
import Nova from './img/Design/novacover.jpg'
import Bibimcos from './img/Design/promotional-design.jpg'
import Bibimcosan from './img/Design/bibimcosancover.jpg';
import Plastic from './img/Design/plasticcover.jpg';
import Mjcare from './img/Design/mjcare_c.jpg'
import Watsons from './img/Design/watsonscover.jpg'
import Square from './img/Design/squarecover.jpg'
import Unfollowers from './img/Design/unfollowerscover.jpg'

import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Sidebar from './Sidebar';

const images = [
  { src: Unfollowers, alt: 'Mobile App Brand Identity and UI UX', title: "Mobile App\nBrand Identity & UI/UX"},
  { src: Square, alt: 'Square! Game Design'},
  { src: Nova, alt: 'Brand Identity Design'},
  { src: Cleaner, alt: 'UI UX Design and Brand Identity'},
  { src: Watsons, alt: 'Watsons X MJCare Collaboration'},
  { src: Bibimcosan, alt: 'Visual Identity and Campaign Design'},
  { src: Program, alt: 'Social Media 2022-2026', title: "Social Media\n2022-2026"},
  { src: Plastic, alt: 'Event Space Design Plastic Free Festival', title: "Event Space Design\nPlastic Free Festival"},
  { src: Mjcare, alt: 'Outdoor AD'},
  { src: Bibimcos, alt: 'Promotional Design 02'},
  { src: Box, alt: 'Box Design'},
  { src: Card, alt: "Valentine's Day"},
  { src: NewYear, alt: 'New Year Concept'},
  { src: Lon, alt: 'Concept Game Design'},
   { src: Samsung, alt: 'Flyer Design'},
  
];



const Design = () => {
  

  return (
   
      <div className="App">
        
            <div className='content'>
              <ImageGallery images={images} />
            </div>
        
      </div>
    
  );


  }
export default Design;
